// extracted by mini-css-extract-plugin
export default {"navContainer":"CustomNavTabs_navContainer__Qwi4Z","navBtn":"CustomNavTabs_navBtn__WFUeg","activeNavBtn":"CustomNavTabs_activeNavBtn__wrTXO"};